import React, { Fragment } from "react";
import { useAVToggle, parsedUserAgent } from "@100mslive/react-sdk";
import { VideoOffIcon, VideoOnIcon } from "@100mslive/react-icons";
import { Tooltip } from "@100mslive/roomkit-react";
import IconButton from "../IconButton";
import { isMobile } from "react-device-detect";
import { toast } from "react-toastify";

const isMacOS = parsedUserAgent.getOS().name.toLowerCase() === "mac os";

export const AudioVideoToggle = ({
  inPreview = false,
  inVirtualOfficePreview = false,
  enableAudioToggle = true,
  enableVideoToggle = true,
  isBottomSheetControl = false,
  isRounded = false,
  enabledColor = "white",
}) => {
  const { isLocalVideoEnabled, isLocalAudioEnabled, toggleAudio, toggleVideo } =
    useAVToggle();

  const toggleAudioWrapper = () => {
    toast.success("Microphone " + (isLocalAudioEnabled ? "off" : "on"), {
      autoClose: 500,
      closeButton: false,
      hideProgressBar: true,
      containerId: "Misc",
      bodyClassName:
        "bg-[#E5F5E8] border border-yocket-green-700 rounded-xl !py-4 !px-10 !text-yocket-neutral-900",
      icon: (
        <img
          src={`/svgs/microphone${
            isLocalAudioEnabled ? "-slash" : ""
          }-black.svg`}
          alt=""
          className="w-6 h-6"
        />
      ),
    });

    toggleAudio();
  };
  return (
    <Fragment>
      {enableAudioToggle && toggleAudio ? (
        <Tooltip
          title={
            !isMobile &&
            `Turn ${isLocalAudioEnabled ? "off" : "on"} audio (${
              isMacOS ? "⌘" : "ctrl"
            } + d)`
          }
        >
          <IconButton
            active={isLocalAudioEnabled}
            onClick={toggleAudioWrapper}
            key="toggleAudio"
            data-testid="audio_btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              border: inPreview ? undefined : "none",
              backgroundColor: !isLocalAudioEnabled
                ? "#DB4537"
                : "rgba(255, 255, 255, 0.10)",
              borderRadius: isRounded ? "100%" : 8,
              padding: (isMobile || inPreview) && 12,
              minWidth: 40,
              width: isBottomSheetControl
                ? "100%"
                : isMobile || inPreview
                ? 48
                : "auto",
              height: (isMobile || inPreview) && 48,
              flexGrow: isBottomSheetControl ? 1 : 0,
            }}
          >
            <img
              src={`/svgs/microphone${
                isLocalAudioEnabled
                  ? enabledColor === "black" || inVirtualOfficePreview
                    ? "-black"
                    : ""
                  : "-slash"
              }.svg`}
              alt=""
              className="w-6 h-6"
            />
            {isBottomSheetControl && (
              <span className="text-xs font-bold text-white">
                {isLocalAudioEnabled ? "Unmuted" : "Muted"}
              </span>
            )}
          </IconButton>
        </Tooltip>
      ) : null}
      {enableVideoToggle && toggleVideo ? (
        <Tooltip
          title={`Turn ${isLocalVideoEnabled ? "off" : "on"} video (${
            isMacOS ? "⌘" : "ctrl"
          } + e)`}
        >
          <IconButton
            key="toggleVideo"
            active={isLocalVideoEnabled}
            onClick={toggleVideo}
            data-testid="video_btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              backgroundColor: !isLocalVideoEnabled
                ? "#DB4537"
                : "rgba(255, 255, 255, 0.10)",
              border: inPreview ? undefined : "none",
              borderRadius: isRounded ? "100%" : 8,
              padding: (isMobile || inPreview) && 12,
              minWidth: 40,
              width: isBottomSheetControl
                ? "100%"
                : isMobile || inPreview
                ? 48
                : 48,
              height: (isMobile || inPreview) && 48,
              flexGrow: isBottomSheetControl ? 1 : 0,
            }}
          >
            {!isLocalVideoEnabled ? (
              <VideoOffIcon
                data-testid="video_off_btn"
                style={{ color: "white" }}
              />
            ) : (
              <VideoOnIcon
                data-testid="video_on_btn"
                style={{ color: enabledColor }}
              />
            )}
            {isBottomSheetControl && (
              <span className="text-xs font-bold text-white">Video</span>
            )}
          </IconButton>
        </Tooltip>
      ) : null}
    </Fragment>
  );
};
